import { render, staticRenderFns } from "./pushList.vue?vue&type=template&id=b66bd2b8&"
import script from "./pushList.vue?vue&type=script&lang=js&"
export * from "./pushList.vue?vue&type=script&lang=js&"
import style0 from "./pushList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports